<template>
  <section class="formBox">
    <!-- 付款信息 -->
    <p class="title">已选付款记录：{{otherFormData.flowId.split(',').length}}条</p>
    <section class="box">
      <section class="clearPa">
        <article class="left labelBox">付款金额</article>
        <article class="left error valueBox">{{otherFormData.txnAmt}}元</article>
      </section>
      <section class="clearPa marBox radioBox">
        <el-radio-group v-model="otherFormData.isAutomatic">
          <el-radio :label="1">系统自动转账</el-radio>
          <el-radio :label="0" v-show="!$route.query.type">线下打款</el-radio>
        </el-radio-group>
      </section>
      <section class="clearPa fileBox" v-show="otherFormData.isAutomatic === 0">
        <article class="left labelBox">附件</article>
        <article class="left">
          <qx-uploadFile
            :fileList="otherFormData.file"
            accept="image/*"
            fileType="img"
            :limit="1"
            @uploadRemove="otherFormData.file = []"
            @uploadSuccess="
              (fileList) => otherFormData.file = fileList
            "
          />
        </article>
      </section>
    </section>
    <!-- 付款信息 end -->
    <!-- 审核结果 -->
    <!-- <section v-show="$route.query.type === 'quick'"> -->
    <section v-show="false">
      <p class="title">审核结果</p>
      <section class="box">
        <section class="clearPa marBox radioBox">
          <el-radio-group v-model="otherFormData.chooseResult">
            <el-radio :label="1">同意</el-radio>
            <el-radio :label="2">驳回</el-radio>
          </el-radio-group>
        </section>
        <section class="clearPa marBox">
          <article class="left labelBox">备注</article>
          <article class="left warning">
            <el-input class="inputBox" v-model="otherFormData.desc" placeholder="请输入" />
          </article>
        </section>
      </section>
    </section>
    <!-- 审核结果 end -->
    <!-- 付款账户 -->
    <section class="receiveBox posire" v-show="!$route.query.type">
      <section class="posiab logoBox logoBoxBg">
        <img class="logo posire" src="~images/getPay/pay.png" />
        <img class="arrowImg posiab" src="~images/getPay/arrow.png" />
      </section>
      <p class="title">付款账户</p>
      <section class="box">
        <section class="clearPa marBox radioBox">
          <el-radio-group v-model="otherFormData.payAccountType" @change="handlePayAccountType">
            <el-radio label="public">公户</el-radio>
            <el-radio label="private">私户</el-radio>
          </el-radio-group>
        </section>
        <section class="clearPa marBox">
          <article class="left labelBox">选择账户</article>
          <article class="left warning">
            <el-select
              class="inputBox"
              v-model="otherFormData.payAccId"
              placeholder="请选择"
              @change="handlePayAccChange"
              style="width: 300px"
            >
              <el-option
                v-for="item in payAccountOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </article>
        </section>
        <section
          class="clearPa marBox"
          v-show="otherFormData.payAccBalance || otherFormData.payAccBalance === 0"
        >
          <article class="left labelBox">账户余额</article>
          <article class="left error valueBox">{{otherFormData.payAccBalance}}元</article>
        </section>
      </section>
    </section>
    <!-- 付款账户 end -->
    <!-- 收款账户 -->
    <section class="payBox posire" v-show="!$route.query.type">
      <section class="posiab logoBox">
        <img class="logo posire" src="~images/getPay/receive.png" />
      </section>
      <p class="title">收款账户</p>
      <section class="box">
        <section class="clearPa marBox radioBox">
          <el-radio-group
            v-model="otherFormData.receiveAccountType"
            @change="handleReceiveTypeChange"
          >
            <el-radio label="public">公户</el-radio>
            <el-radio label="private">私户</el-radio>
          </el-radio-group>
        </section>
        <section class="clearPa marBox">
          <article class="left labelBox">选择账户</article>
          <article class="left warning">
            <el-select
              class="inputBox"
              v-model="otherFormData.accId"
              placeholder="请选择"
              @change="handleAccChange"
              style="width: 300px"
            >
              <el-option
                v-for="item in receiveAccountOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </article>
        </section>
        <section class="clearPa marBox" v-show="otherFormData.accBankName">
          <article class="left labelBox">开户银行</article>
          <article class="left valueBox">{{otherFormData.accBankName}}</article>
        </section>
      </section>
    </section>
    <!-- 收款账户 end -->
    <PwdDialog ref="pwdDialog" @sub="pwdDialogSuccess" @checkMsg="checkMsg" />
    <CheckPwdByMsgDialog ref="checkPwdByMsgDialog" @sub="checkPwdByMsgDialogSuccess" />
  </section>
</template>

<script>
import {
  bankcardAccountList,
  queryQuickAccount,
  doQueryCheckPasswordErr,
  balanceJudgment,
  doQueryPassType,
} from 'api/getPay';
import PwdDialog from './pwdDialog';
import CheckPwdByMsgDialog from './checkPwdByMsgDialog';
export default {
  components: {
    PwdDialog,
    CheckPwdByMsgDialog,
  },
  data () {
    return {
      payoutInfo: {},
      receiveAccountPublicOptions: [],
      receiveAccountPrivateOptions: [],
      payAccountPublicOptions: [],
      payAccountPrivateOptions: [],
      otherFormData: {
        flowId: '',
        txnAmt: '',
        isAutomatic: -1, // 打款方式
        chooseResult: 1, // 审核结果
        desc: '', // 备注
        payAccountType: 'public', // 付款账户类型
        payAccId: '', // 付款账户
        payAccBalance: '',
        receiveAccountType: 'public', // 收款账户类型
        accId: '', // 收款账户
        accBankName: '',
        file: [], // 附件
      },
    };
  },
  computed: {
    receiveAccountOptions () {
      if (this.otherFormData.receiveAccountType === 'public') {
        return this.receiveAccountPublicOptions;
      } else {
        return this.receiveAccountPrivateOptions;
      }
    },
    payAccountOptions () {
      if (this.otherFormData.payAccountType === 'public') {
        return this.payAccountPublicOptions;
      } else {
        return this.payAccountPrivateOptions;
      }
    },
  },
  methods: {
    pwdDialogSuccess () {
      this.$emit('pwdDialogSuccess');
    },

    checkMsg (billId) {
      this.$nextTick(() => {
        this.$refs.checkPwdByMsgDialog.show({ billId });
      });
    },

    checkPwdByMsgDialogSuccess () {
      this.$emit('checkPwdByMsgDialogSuccess');
    },

    handlePayAccountType () {
      this.otherFormData.payAccId = '';
      this.otherFormData.payAccBalance = '';

      this.setAccountInfo(this.otherFormData, 'pay', 'payAccId');
      this.handlePayAccChange();
    },

    handlePayAccChange () {
      if (!this.otherFormData.payAccId) {
        return;
      }
      for (let i = 0; i < this.payAccountOptions.length; i++) {
        if (this.payAccountOptions[i].value === this.otherFormData.payAccId) {
          this.otherFormData.payAccBalance = this.payAccountOptions[i].balance;
          break;
        }
      }
    },

    handleReceiveTypeChange () {
      this.otherFormData.accId = '';
      this.otherFormData.accBankName = '';

      this.setAccountInfo(this.otherFormData, 'receive', 'accId');
      this.handleAccChange();
    },

    handleAccChange () {
      if (!this.otherFormData.accId) {
        return;
      }
      for (let i = 0; i < this.receiveAccountOptions.length; i++) {
        if (this.receiveAccountOptions[i].value === this.otherFormData.accId) {
          this.otherFormData.accBankName = this.receiveAccountOptions[i].bankName;
          break;
        }
      }
    },
    async getList (data) {
      // 付款账户 - 对私
      const payPrivateRes = await bankcardAccountList({
        bankType: '222',
        isNeedHa: 0,
        type: 0,
        userType: 6,
      });
      if (payPrivateRes && payPrivateRes.items && payPrivateRes.items.length) {
        this.payAccountPrivateOptions = payPrivateRes.items.map((item) => ({
          label: item.acctName,
          value: item.acctNo,
          balance: item.balanceDouble,
          bankName: item.bankName,
        }));
      }
      // 付款账户 - 对公
      const payPublicRes = await bankcardAccountList({
        bankType: '111',
        isNeedHa: 0,
        type: 1,
        userType: 6,
      });
      if (payPublicRes && payPublicRes.items && payPublicRes.items.length) {
        this.payAccountPublicOptions = payPublicRes.items.map((item) => ({
          label: item.acctName,
          value: item.acctNo,
          balance: item.balanceDouble,
          bankName: item.bankName,
        }));
      }

      // 收款账户 - 对私
      const receivePrivateRes = await bankcardAccountList({
        bankType: '222',
        isNeedHa: 0,
        type: 0,
        userType: this.$route.query.userType,
        userId: this.$route.query.userId,
        // userId:'470606346331033'
      });
      if (receivePrivateRes && receivePrivateRes.items && receivePrivateRes.items.length) {
        this.receiveAccountPrivateOptions = receivePrivateRes.items.map((item) => ({
          label: item.acctName,
          value: item.acctNo,
          balance: item.balanceDouble,
          bankName: item.bankName,
        }));
      }
      // 收款账户 - 对公
      const receivePublicRes = await bankcardAccountList({
        bankType: '111',
        isNeedHa: 0,
        type: 1,
        userType: this.$route.query.userType,
        userId: this.$route.query.userId,
        // userId:'470606346331033'
      });
      if (receivePublicRes && receivePublicRes.items && receivePublicRes.items.length) {
        this.receiveAccountPublicOptions = receivePublicRes.items.map((item) => ({
          label: item.acctName,
          value: item.acctNo,
          balance: item.balanceDouble,
          bankName: item.bankName,
        }));
      }

      if (this.$route.query.ids) {
        const resPayOutInfo = await queryQuickAccount({
          flowId: this.$route.query.ids.split(',')[0],
        });
        if (!resPayOutInfo.failed) {
          this.payoutInfo = resPayOutInfo;
          // 收款账户
          data.receiveAccountType = (this.payoutInfo.bankType !== null && this.payoutInfo.bankType === 1) ? 'public' : 'private';
          this.setAccountInfo(data, 'receive', 'accId');
          // 付款账户，默认是私户
          data.payAccountType = 'private';
          this.setAccountInfo(data, 'pay', 'payAccId');
          console.log(this.payoutInfo);
        }
      }
    },

    // 设置 付款/收款 账户信息
    setAccountInfo (obj, typeName, accIdName) {
      if (obj[typeName + 'AccountType'] === 'public') {
        if (this[typeName + 'AccountPublicOptions'].length) {
          if (!obj[accIdName]) {
            obj[accIdName] = this[typeName + 'AccountPublicOptions'][0].value;
          }
        }
      } else if (obj[typeName + 'AccountType'] === 'private') {
        if (this[typeName + 'AccountPrivateOptions'].length) {
          if (!obj[accIdName]) {
            obj[accIdName] = this[typeName + 'AccountPrivateOptions'][0].value;
          }
        }
      }
    },
    async sub () {
      if (this.otherFormData.isAutomatic === -1) {
        this.$message.warning('请选择【系统自动转账】或【线下打款】');
        return null;
      }

      if (this.$route.query.type === 'quick') {
        // 给多个收款人
        if (this.payAccountPublicOptions.length === 0 && this.payAccountPrivateOptions.length === 0) {
          this.$message.warning('请先创建公司银行账号');
        } else if (this.payAccountPrivateOptions.length !== 0) {
          this.otherFormData.payAccId = this.payAccountPrivateOptions[0].value;
        } else {
          this.otherFormData.payAccId = this.payAccountPublicOptions[0].value;
        }
        const quickAccouontRes = await queryQuickAccount({
          flowId: this.$route.query.ids.split(',')[0],
        });
        this.otherFormData.accId = quickAccouontRes.accNo;

        if (!this.otherFormData.accId) {
          const confirmRes = await this.$confirm('温馨提示：收款人还没有绑定银行卡，但您仍可支付成功，只要收款人成功绑卡就可以提现。付款成功后，车队账户相应账户的资金减少，收款方账户资金增加。', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).catch(() => { // 取消删除
          });
          if (confirmRes === 'confirm') {
            return this.otherFormData;
          } else {
            return null;
          }
        }
        if (this.otherFormData.isAutomatic === 0 && this.otherFormData.file[0]) {
          // 线下付款，上传附件
          this.otherFormData.fileId = this.otherFormData.file[0].id;
          this.otherFormData.fileUrl = this.otherFormData.file[0].url;
        }
        delete this.otherFormData.file;
        const result = JSON.parse(JSON.stringify(this.otherFormData));
        if (this.$route.query.type === 'quick') {
          result.isAutomatic = 1;
          result.userType = 3;
          delete result.txnAmt;
          delete result.payAccountType;
          delete result.receiveAccountType;
          delete result.file;
        }
        return result;
      } else {
        // 给一个收款人
        const formData = await this.toPayForOnePerson();
        return formData;
      }
    },
    // 给一个收款人
    async toPayForOnePerson () {
      const resCheckPwdErr = await doQueryCheckPasswordErr();
      // 检测是否需要密码
      if (resCheckPwdErr === '2') {
        // 需要密码
        return this.judgment();
      } else {
        const resPayFront = await this.payFront();
        return resPayFront;
      }
    },
    // 查询是否可以直接输入密码
    async judgment () {
      const resDoqueryPassType = await doQueryPassType();
      if (resDoqueryPassType !== 'Y') {
        // 输入密码错误次数太多，需要弹出短信验证码弹窗处理
        this.checkMsg(resDoqueryPassType);
      } else {
        // 弹出直接输入密码弹窗
        this.$refs.pwdDialog.show();
      }
      // 此处返回 null 意味着表单提交的操作到此为止，因为已经弹出了其他弹窗中断了提交操作
      return null;
    },

    // 不需要密码，直接付款
    async payFront () {
      let formData = null;
      const flowId = this.$route.query.ids.split(',')[0];
      this.otherFormData.flowId = flowId;
      // 判断【系统自动转账】还是【线下打款】
      if (this.otherFormData.isAutomatic === 1) {
        // 系统自动转账（线上打款）
        const payAccountType = this.otherFormData.payAccountType;
        const type = payAccountType === 'public' ? 1 : 2;
        const userType = this.$route.query.userType;
        const resBalanceJudgment = await balanceJudgment({
          payPinganPayAcctId: this.otherFormData.payAccId,
          type,
          balance: (this.otherFormData.txnAmt * 100).toFixed(2),
          payAccNo: this.otherFormData.payAccId,
          accNo: this.otherFormData.accId,
        });

        if (resBalanceJudgment.state === '1') {
          let msg = '确认系统自动打款到对方帐户？';
          if (this.payoutInfo.subjectsId === 1653 && type === 2) {
            msg = '当前所选的付款账户为私户，确认使用该账户给油供应商付款？';
          }
          if (userType === 3 && !this.otherFormData.accId) {
            msg = '收款人还没有绑定银行卡，但您仍可支付成功，只要收款人成功绑卡就可以提现。付款成功后，车队账户相应账户的资金减少，收款方账户资金增加。';
          }
          const confirmRes = await this.$confirm(msg, '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).catch(() => {
            // 取消
          });
          if (confirmRes === 'confirm') {
            formData = this.otherFormData;
          }
        } else if (resBalanceJudgment.state === '2') {
          const confirmRes = await this.$confirm('自动转账由于支出账户余额不足，您可以先将收入账户余额转入到支出账户或线下进行充值后，再进行付款操作。', '温馨提示', {
            confirmButtonText: '前往转移资金',
            cancelButtonText: '取消',
            type: 'warning',
          }).catch(() => {
            // 取消
          });
          if (confirmRes === 'confirm') {
            const params = `?type=${payAccountType}&bankType=${type}&amount=${this.otherFormData.txnAmt}&payPinganPayAcctId=${this.otherFormData.payAccId}&userType=${this.payoutInfo.payUserType}`;
            this.jump({
              label: (payAccountType === 'public' ? '对公' : '对私') + '账户资金互转',
              url: `/manage/getPay/account/platform/changeMoney${params}`,
              full: true,
            });
          }
        } else if (resBalanceJudgment.state === '3') {
          const confirmRes = await this.$confirm('自动转账支出账户余额不足，请先充值。', '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).catch(() => {
            // 取消
          });
          if (confirmRes === 'confirm') {
            formData = null;
          }
        }
      } else if (this.otherFormData.isAutomatic === 0) {
        // 线下打款
        if (this.$route.query.ids) {
          if (this.otherFormData.file && this.otherFormData.file.length) {
            this.otherFormData.fileId = this.otherFormData.file[0].id;
            this.otherFormData.fileUrl = this.otherFormData.file[0].url;
          }
          const confirmRes = await this.$confirm('确认线下打款？', '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).catch(() => {
            // 取消
          });
          if (confirmRes === 'confirm') {
            delete this.otherFormData.file;
            formData = {
              ...this.otherFormData,
              payAccNo: this.otherFormData.payAccId,
              accNo: this.otherFormData.accId,
            };
          }
        } else {
          formData = null;
        }
      }
      if (formData) {
        if (!formData.userType) {
          formData.userType = this.$route.query.userType;
        }
      }
      return formData;
    },
    async cacheData () {
      return this.otherFormData;
    },
    async init (data = {}) {
      this.otherFormData.isAutomatic = -1;
      await this.getList(data);
      data.flowId = this.$route.query.ids;
      data.txnAmt = this.$route.query.txnAmt;
      if (data.isAutomatic === undefined || data.isAutomatic === null) { // 打款方式
        data.isAutomatic = -1;
        if (this.$route.query.type === 'quick') {
          // 如果是给多个收款人（一键支付）
          data.isAutomatic = 1;
        }
      }
      if (!data.chooseResult) { // 审核结果
        data.chooseResult = 1;
      }
      if (!data.payAccountType) { // 付款账户类型
        data.payAccountType = 'public';
      }
      if (!data.receiveAccountType) { // 收款账户类型
        data.receiveAccountType = 'public';
      }
      if (data.payAcc === undefined || data.payAcc === null) {
        data.payAcc = {};
      }
      if (data.acc === undefined || data.acc === null) {
        data.acc = {};
      }
      this.setFormVal(this.otherFormData, data);
      this.handlePayAccChange();
      this.handleAccChange();
    },
  },
};
</script>

<style scoped lang="scss">
.fileBox {
  margin: 16px 0;
}
.formBox {
  padding-left: 336px;
  padding-bottom: 50px;
  .title {
    height: 55px;
    line-height: 55px;
    color: #333;
  }
  .box {
    width: 560px;
    padding: 4px 16px;
    border: 1px solid #e0e0e0;
  }
  .labelBox {
    padding-right: 16px;
    height: 32px;
    line-height: 32px;
    width: 56px;
    text-align: right;
  }
  .valueBox {
    font-size: 16px;
    height: 32px;
    line-height: 32px;
  }
  .marBox {
    padding: 8px 0;
  }
  .radioBox {
    padding-left: 8px;
  }
  .logoBox {
    top: 12px;
    left: -40px;
    height: 100%;
    width: 4px;
    .logo {
      width: 32px;
      height: 32px;
      left: -14px;
    }
    .arrowImg {
      width: 16px;
      height: 16px;
      top: 116px;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .logoBoxBg {
    background: #e6f7ff;
  }
}
</style>
